import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetPlayheadSyncStatusMutationVariables = Types.Exact<{
  input: Types.SetPlayheadSyncStatusInput;
}>;


export type SetPlayheadSyncStatusMutation = { __typename?: 'Mutation', setPlayheadSyncStatus: { __typename?: 'PlayheadSyncStatus', assetId: string, status: Types.PlayheadSyncStatusState, sequenceId: string } };


export const SetPlayheadSyncStatus = /*#__PURE__*/ gql`
    mutation SetPlayheadSyncStatus($input: SetPlayheadSyncStatusInput!) {
  setPlayheadSyncStatus(input: $input) {
    assetId
    status
    sequenceId
  }
}
    ` as unknown as DocumentNode<SetPlayheadSyncStatusMutation, SetPlayheadSyncStatusMutationVariables>;

          

          export const useSetPlayheadSyncStatusMutation = (options?:MutationHookOptions<SetPlayheadSyncStatusMutation, SetPlayheadSyncStatusMutationVariables>) => useMutation(SetPlayheadSyncStatus, options);
          

          export type SetPlayheadSyncStatusMutationOptions = MutationHookOptions<SetPlayheadSyncStatusMutation, SetPlayheadSyncStatusMutationVariables>;

          

          export type SetPlayheadSyncStatusMutationResult = ReturnType<typeof useSetPlayheadSyncStatusMutation>[1];

          
